"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Section_1 = require("../../defaults/Section");
var Text_1 = __importDefault(require("./Text"));
var _helpers_1 = require("../../helpers");
var _styled_1 = require("../../styled-components");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Hr_1 = __importDefault(require("./Hr"));
var SectionElement = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  background-position: ", ";\n  background-size: ", ";\n  overflow: hidden;\n"], ["\n  background: ",
    ";\n  background-position: ",
    ";\n  background-size: ",
    ";\n  overflow: hidden;\n"])), function (_a) {
    var dark = _a.dark, theme = _a.theme, backgroundImage = _a.backgroundImage, defaultCss = _a.defaultCss;
    if (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.backgroundColor)
        return defaultCss.backgroundColor;
    if (backgroundImage && backgroundImage.overlay)
        return "linear-gradient(\n    " + backgroundImage.overlay + ",\n    " + backgroundImage.overlay + "\n    ), " + backgroundImage.src;
    if (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src)
        return backgroundImage.src;
    if (dark)
        return theme.bgDark;
    return theme.bgLight;
}, function (_a) {
    var backgroundImage = _a.backgroundImage;
    return backgroundImage ? backgroundImage.position : null;
}, function (_a) {
    var backgroundImage = _a.backgroundImage;
    return (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.size) ? backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.size : null;
});
var Section = function (_a) {
    var id = _a.id, children = _a.children, _b = _a.container, container = _b === void 0 ? true : _b, titleConfig = _a.titleConfig, subtitleConfig = _a.subtitleConfig, descriptionConfig = _a.descriptionConfig, _c = _a.dark, dark = _c === void 0 ? Section_1.defaultSectionConfig.dark : _c, _d = _a.padding, padding = _d === void 0 ? Section_1.defaultSectionConfig.padding : _d, _e = _a.margin, margin = _e === void 0 ? Section_1.defaultSectionConfig.margin : _e, backgroundImage = _a.backgroundImage, _f = _a.showHr, showHr = _f === void 0 ? false : _f, hrConfig = _a.hrConfig, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps;
    var mergedTitleConfig = _helpers_1.merge(Section_1.defaultSectionConfig.titleConfig, titleConfig);
    var mergedSubtitleConfig = _helpers_1.merge(Section_1.defaultSectionConfig.subtitleConfig, subtitleConfig);
    var mergedDescriptionConfig = _helpers_1.merge(Section_1.defaultSectionConfig.descriptionConfig, descriptionConfig);
    return (react_1.default.createElement(SectionElement, __assign({ id: id, dark: dark, padding: padding, margin: margin, backgroundImage: backgroundImage, defaultCss: defaultCss }, nativeProps),
        react_1.default.createElement("div", { className: container ? 'container' : '' },
            (mergedTitleConfig === null || mergedTitleConfig === void 0 ? void 0 : mergedTitleConfig.text) && react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedTitleConfig)),
            (mergedSubtitleConfig === null || mergedSubtitleConfig === void 0 ? void 0 : mergedSubtitleConfig.text) && (react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedSubtitleConfig))),
            (mergedDescriptionConfig === null || mergedDescriptionConfig === void 0 ? void 0 : mergedDescriptionConfig.text) && (react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedDescriptionConfig))),
            showHr && react_1.default.createElement(Hr_1.default, __assign({}, Section_1.defaultSectionConfig.hrConfig, hrConfig)),
            children)));
};
exports.default = Section;
var templateObject_1;
//# sourceMappingURL=Section.js.map